import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import Footer from '../components/Footer';

const Welcome: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div 
      className="min-h-screen flex flex-col"
      style={{ 
        background: 'linear-gradient(to bottom, #0c0d1f, #1b1324)'
      }}
    >
      {/* Header with Logo */}
      <header className="w-full px-6 md:px-12 lg:px-20 py-6 flex items-center">
        <Link to="/dashboard" className="flex items-center gap-2">
          <img src="/images/logo.png" alt="AdSmash Logo" className="h-10 md:h-12" />
        </Link>
      </header>

      {/* Main Content */}
      <main className="flex-1 flex items-center justify-center px-6 md:px-12 lg:px-20 py-8 md:py-12">
        <div className="max-w-2xl w-full text-center">
          {/* Success Icon */}
          <div className="mx-auto mb-8 flex h-20 w-20 items-center justify-center rounded-full bg-emerald-500/10 text-emerald-400">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="h-10 w-10">
              <path
                fillRule="evenodd"
                d="M10.378 3.21c.755-2.274 3.189-2.274 3.944 0l.745 2.245c.118.355.45.599.826.599h2.362c2.386 0 3.366 1.927 2.19 4.162l-1.318 2.474a1.104 1.104 0 0 0 0 1.013l1.318 2.474c1.176 2.235.196 4.162-2.19 4.162h-2.362c-.376 0-.708.244-.826.6l-.745 2.244c-.755 2.274-3.189 2.274-3.944 0l-.745-2.245a.907.907 0 0 0-.826-.599H6.445c-2.386 0-3.366-1.927-2.19-4.162l1.318-2.474a1.104 1.104 0 0 0 0-1.013L4.255 10.216c-1.176-2.235-.196-4.162 2.19-4.162h2.362c.376 0 .708-.244.826-.6l.745-2.244Zm4.522 8.79a.9.9 0 0 0-1.246-1.3l-2.955 2.83-1.352-1.295a.9.9 0 0 0-1.246 1.3l1.975 1.891a.9.9 0 0 0 1.246 0l3.578-3.426Z"
                clipRule="evenodd"
              />
            </svg>
          </div>

          {/* Main Title */}
          <h1 
            className="font-bold text-white mb-6 leading-tight"
            style={{ fontSize: '2.5rem' }}
          >
            Welcome to AdSmash! 🎉
          </h1>

          {/* Description */}
          <p className="text-white/70 mb-8 text-lg" style={{ fontSize: '1.125rem' }}>
            You're all set! Your ad blocker is now active and protecting your browsing experience.
          </p>

          {/* Features List */}
          <div className="bg-white/5 backdrop-blur rounded-2xl p-6 border border-white/10 mb-8 text-left">
            <h2 className="text-white font-semibold mb-4" style={{ fontSize: '1.125rem' }}>
              What's next?
            </h2>
            <ul className="space-y-3">
              <li className="flex items-start gap-3 text-white/90">
                <img 
                  src="/images/tick.png" 
                  alt="Checkmark" 
                  className="flex-shrink-0 mt-0.5"
                  style={{ width: '1rem', height: '1rem' }}
                />
                <span>Ads are now being blocked automatically</span>
              </li>
              <li className="flex items-start gap-3 text-white/90">
                <img 
                  src="/images/tick.png" 
                  alt="Checkmark" 
                  className="flex-shrink-0 mt-0.5"
                  style={{ width: '1rem', height: '1rem' }}
                />
                <span>Pages will load faster without ad scripts</span>
              </li>
              <li className="flex items-start gap-3 text-white/90">
                <img 
                  src="/images/tick.png" 
                  alt="Checkmark" 
                  className="flex-shrink-0 mt-0.5"
                  style={{ width: '1rem', height: '1rem' }}
                />
                <span>Trackers and cookies are being blocked</span>
              </li>
              <li className="flex items-start gap-3 text-white/90">
                <img 
                  src="/images/tick.png" 
                  alt="Checkmark" 
                  className="flex-shrink-0 mt-0.5"
                  style={{ width: '1rem', height: '1rem' }}
                />
                <span>Manage your subscription from your dashboard</span>
              </li>
            </ul>
          </div>

          {/* CTA Button */}
          <button
            onClick={() => navigate('/dashboard')}
            className="btn-adsmash-primary text-white px-12 py-4 rounded-md font-semibold transition-all shadow-lg"
            style={{ fontSize: '1rem' }}
          >
            Go to Dashboard
          </button>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default Welcome;

